import {landingPage, mainPage} from './routes'

export function getFirstRoute (validationRequired, newUser, redirectPage) {
  if (validationRequired || newUser) return landingPage
  if (redirectPage) return redirectPage
  return mainPage
}

export default getFirstRoute



// WEBPACK FOOTER //
// ./src/router/workflow.js